/**
 * Traverses first argument and if `lazyUrlEndpoint` is found
 * then saves the path and its value to update it back right after
 */
export const traverseLazyUrlEndpoints = (data: any, urls: Map<string, string>, path?: string) => {
  if (!data || typeof data !== 'object') return
  if (data.lazyUrlEndpoint && path) {
    urls.set(path, data.lazyUrlEndpoint)
  }

  const entries = Object.entries(data)
  entries.forEach(([key, value]) => {
    const currentPath = path ? `${path}/${key}` : key
    if (typeof value === 'object') {
      traverseLazyUrlEndpoints(value, urls, currentPath)
    }
  })
}

// This needs to run in Nuxt context to use `$fetch`
export const handleLazyUrlsMapping = async (pageData: any) => {
  // Contains property path of the link object and the lazyUrlEndpoint
  const urls = new Map<string, string>()
  traverseLazyUrlEndpoints(pageData, urls)

  const urlsAssociation = [...urls]

  const resolvedLinks: [string, string | null][] = []
  for (const [key, value] of urlsAssociation) {
    if (!key || !value) continue
    try {
      const response = await $fetch<{ link: string | null }>(value)
      // Saves the path and the newly fetched link that can be null
      resolvedLinks.push([key, response.link])
    } catch (e) {
      console.error("[ERROR]: Couldn't fetch the lazyUrlEndpoint: ", value, e)
    }
  }

  const fetchedUrls = new Map<string, string | null>(resolvedLinks)

  // IMPORTANT: Mutates the pageData object
  fetchedUrls.forEach((value, key) => {
    if (!key) return
    const properties = key.split('/')

    // Traverse the object through the pre-saved key
    // Starts by getting the reference of the object
    let obj: any = pageData
    properties.forEach((prop, index, arr) => {
      if (!obj) return
      // Updates the reference of the object
      obj = obj[prop]
      // if at the end of the object, remove `lazyUrlEndpoint` and update `url`
      if (index === arr.length - 1 && obj.lazyUrlEndpoint) {
        obj.url = value
        obj.lazyUrlEndpoint = null
      }
    })
  })
}
